import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import './App.css';
import EnterScreen from './components/EnterScreen';
import Desktop from './components/Desktop';

function setFullHeight() {
  document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
}
window.addEventListener('resize', setFullHeight);
setFullHeight();

function App() {
  const [isLaunched, setIsLaunched] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const path = location.pathname;

    if (
      path.startsWith('/about') ||
      path.startsWith('/portfolio') ||
      path.startsWith('/gallery') ||
      path.startsWith('/news') ||
      path.startsWith('/contact') ||
      path.startsWith('/recycle')
    ) {
      setIsLaunched(true);
    }

  }, [location.pathname]);

  return (
    <>
      <Helmet>
        {window.location.hostname === 'dev.weareasite.com' && (
          <meta name="robots" content="noindex, nofollow" />
        )}
        <link rel="canonical" href={`https://weareasite.com${location.pathname}`} />
      </Helmet>

      <div className="App full-height">
        {isLaunched ?
          <Desktop isLaunched={isLaunched} setIsLaunched={setIsLaunched} />
          :
          <EnterScreen isLaunched={isLaunched} setIsLaunched={setIsLaunched} />
        }
      </div>
    </>
  );
}

export default App;
